<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M7.46455 16.0037C7.31983 16.1416 7.09232 16.1418 6.94742 16.004L1.53233 10.8553C1.37818 10.7087 1.37667 10.4634 1.52901 10.315L2.5566 9.3136C2.70121 9.17268 2.93144 9.17157 3.07741 9.31108L6.94744 13.0098C7.09223 13.1482 7.32021 13.1484 7.46522 13.0102L16.9251 3.99685C17.0701 3.85869 17.2981 3.85886 17.4429 3.99725L18.466 4.97502C18.6206 5.12285 18.6205 5.36993 18.4656 5.51756L7.46455 16.0037Z"
			:fill="computedFill"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconCheck',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
